/* @flow strict */

import * as React from 'react';
import useOutsideClick from './../../utils/useOutsideClick';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import './styles.scss';

type PropsType = {
  selected: string,
  email?: any,
  className?: string,
  item: [
    {
      label: string | React.Node,
      attr?: any,
      callback: () => void
    }
  ],
  isLoading?: boolean
};

const Dropdown = (props: PropsType): React.Element<typeof React.Fragment> => {
  const [isShowDropdown, handleShowDropdown] = React.useState(false);
  const ref = React.useRef();

  useOutsideClick(ref, () => {
    handleShowDropdown(false);
  });

  return (
    <>
      <div className={`DropdownWrap DropdownWrap-${props.className}`} ref={ref}>
        <div
          className={`DropdownLogo ${isShowDropdown ? 'Dropdown-isOpen' : ''} ${props.isLoading ? 'csspinner' : ''}`}
          onClick={(): any => handleShowDropdown(!isShowDropdown)}
        >
        <CTooltip>
          <CTooltipLabel>
            {props.selected}
          </CTooltipLabel>
          <CTooltipText styles={{ fontSize: '14px', backgroundColor: '#E1E3E7', color: '#000', left: '-10px', top: '75px', }}>{props.email ?? ''}</CTooltipText>
        </CTooltip>
          
        </div>

        {isShowDropdown ?
          <ul className="Dropdown">
            {_.map(props.item, (it: {}, ind: number): React.Element => {
              return (
                <li
                  key={`DropdownItem-${ind}`}
                  className="DropdownItem"
                  {...it.attr}
                  onClick={(e: any) => {
                   if (it.callback) {
                     it.callback(e);
                   }

                   handleShowDropdown(false);
                  }}
                >
                  {it.label}
                </li>
              );
            })}
          </ul> : null}
      </div>
    </>
  );
};

export default Dropdown;
